export const getExpenseJournalList = state => {
    return state.list
}

export const getExpenseJournalDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseJournal/getters.js